<template>
    <rkm-modal
        @cancel="reset"
        @close="reset"
        @hide="reset"
        persistent
        ref="Modal"
        title="Opções de impressão"
    >
        <rkm-form-checkbox
            v-model="model.selectedAll"
            :indeterminate="indeterminate"
        >
            Todos
        </rkm-form-checkbox>

        <rkm-form-checkbox-group
            :options="form.impressoes"
            stacked
            v-model="model.impressoes"
        />

        <template v-slot:footer="{ cancel }">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                :disabled="model.impressoes.length === 0"
                @click="print"
                color="primary"
            >
                Imprimir
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
import { repository, request } from '@/mixins'

export default {
    computed: {
        indeterminate() {

            return this.model.impressoes.length > 0
                && this.form.impressoes.length !== this.model.impressoes.length
        }
    },
    created() {

        this.repositories = {
            impressao: this.getConectaSusRepository('impressao.prontoAtendimento')
        }
    },
    data: () => ({
        callbackOnClose: null,
        internacaoId: null,
        form: {
            impressoes: [],
        },
        model: {
            selectedAll: false,
            impressoes: [],
        },
    }),
    mixins: [repository, request],
    methods: {
        open(internacaoId, impressoes, callbackOnClose = null) {

            this.internacaoId = internacaoId
            this.form.impressoes = impressoes
            this.model.selectedAll = true
            this.callbackOnClose = callbackOnClose

            this.$refs.Modal.show()
        },
        print() {

            const impressoes = {
                laudo: () => this.repositories.impressao.aih.laudo(this.internacaoId),
                termoResponsabilidade: () => this.repositories.impressao.aih.termoResponsabilidade(this.internacaoId),
            }

            this.model.impressoes.forEach(i => this.openFile(impressoes[i]))
        },
        openFile(repository) {

            this.fetch(repository)
                .then(response => {

                    const content = new Blob([response.data], { type: response.headers['content-type'] })
                    const url = URL.createObjectURL(content)
                    const link = document.createElement('a')

                    link.href = url
                    link.target = '_blank'
                    link.click()
                    link.remove()
                })
        },
        reset() {

            this.form.impressoes = []
            this.model.impressoes = []
            this.model.selectedAll = false

            if (typeof this.callbackOnClose === 'function') {

                this.callbackOnClose()
            }
        }
    },
    watch: {
        'model.selectedAll': function (selectedAll) {

            this.model.impressoes = selectedAll
                ? this.form.impressoes.filter(i => !i.disabled).map(i => i.value)
                : []
        },
        'model.impressoes': function (impressoes) {

            if (impressoes.length === 0) {

                this.model.selectedAll = false
            }
            else if (impressoes.length === this.form.impressoes.length) {

                this.model.selectedAll = true
            }
        }
    }
}
</script>